import _ from 'lodash/fp';
import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware, ActionsObservable } from 'redux-observable';
import { composeWithDevTools } from 'redux-devtools-extension';
import createLogger from 'redux-logger';
import reducers from './reducers';
import epics from './epics';

ActionsObservable.prototype.ofAction = function(...actions) {
  return this
    .ofType(...actions.map(action => action.toString()))
    .map(_.prop('payload'));
};

const epicMiddleware = createEpicMiddleware(epics);
const loggerMiddleware = createLogger();

export default createStore(
  reducers,
  composeWithDevTools(applyMiddleware(epicMiddleware))
);



// WEBPACK FOOTER //
// ./src/store.js